import React, { useState, useEffect, useCallback } from 'react';

const ShareSection = () => {
  const [shareLink, setShareLink] = useState('https://www.management-crown.web.id/');
  const [showSuccess, setShowSuccess] = useState(false);

  const addReferralParameter = useCallback(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const referralCode = urlParams.get('ref');
    
    if (referralCode) {
      const currentUrl = 'https://www.management-crown.web.id/'; // Gunakan base URL
      const separator = currentUrl.includes('?') ? '&' : '?';
      const newUrl = currentUrl + separator + 'ref=' + referralCode;
      setShareLink(newUrl);
      localStorage.setItem('referralCode', referralCode);
    }
  }, []);

  useEffect(() => {
    addReferralParameter();
  }, [addReferralParameter]); // Sekarang dependensi sudah benar

  const shareToWhatsApp = () => {
    const message = `Halo! Saya menemukan kesempatan menarik untuk menjadi Host di MOMOLIVE melalui CROWN MANAGEMENT! 🎉

🎯 *KEUNTUNGAN UNTUK HOST:*
• New Host: Rp 20.000/hari (2 jam)
• Level A: Rp 50.000/hari
• Level S: Rp 100.000/hari
• Level SS: Rp 180.000/hari
• Bonus Share Gift: 70% dari semua gift!

📋 *SYARAT:*
✓ Minimal 18 tahun
✓ Punya KTP & rekening bank
✓ Ramah & komunikatif
✓ Tidak malu di depan kamera

💼 *BENEFIT:*
• Gaji pokok harian
• Bonus tambahan
• Jam kerja fleksibel
• Support dari agensi

🔗 *DAFTAR SEKARANG:*
${shareLink}

📞 *KONTAK:*
https://wa.me/62811248168

Yuk bergabung dan raih penghasilan menarik bersama kami! 🚀`;
    
    const encodedMessage = encodeURIComponent(message);
    const whatsappURL = `https://wa.me/?text=${encodedMessage}`;
    
    window.open(whatsappURL, '_blank');
  };

  const shareToTelegram = () => {
    const message = `🎯 *OPEN RECRUITMENT HOST MOMOLIVE* 🎯

Bergabunglah dengan CROWN MANAGEMENT dan raih penghasilan menarik!

🔗 Link Pendaftaran: ${shareLink}

📞 WhatsApp: https://wa.me/62811248168

#Momolive #Recruitment #Host #LiveStreaming`;
    
    const encodedMessage = encodeURIComponent(message);
    const telegramURL = `https://t.me/share/url?url=${encodeURIComponent(shareLink)}&text=${encodedMessage}`;
    
    window.open(telegramURL, '_blank');
  };

  const shareToFacebook = () => {
    const facebookURL = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareLink)}`;
    window.open(facebookURL, '_blank', 'width=600,height=400');
  };

  const copyToClipboard = () => {
    navigator.clipboard.writeText(shareLink).then(() => {
      setShowSuccess(true);
      setTimeout(() => setShowSuccess(false), 3000);
    }).catch(err => {
      console.error('Gagal menyalin: ', err);
    });
  };

  return (
    <section className="share-section" id="share">
      <div className="container">
        <div className="share-container">
          <h2>Bagikan Info Ini ke Teman Anda</h2>
          <p>Dapatkan bonus referal dengan membagikan link ini ke teman-teman Anda!</p>
          
          <div className="share-input-group">
            <input 
              type="text" 
              className="share-input" 
              value={shareLink} 
              readOnly 
              onChange={(e) => setShareLink(e.target.value)}
            />
            <button className="copy-button" onClick={copyToClipboard}>
              <i className="fas fa-copy"></i> Salin
            </button>
          </div>
          
          <div className={`success-message ${showSuccess ? 'show' : ''}`}>
            Link berhasil disalin!
          </div>
          
          <div className="share-buttons">
            <button className="share-button whatsapp" onClick={shareToWhatsApp}>
              <i className="fab fa-whatsapp"></i> Bagikan ke WhatsApp
            </button>
            <button className="share-button telegram" onClick={shareToTelegram}>
              <i className="fab fa-telegram"></i> Bagikan ke Telegram
            </button>
            <button className="share-button copy" onClick={shareToFacebook}>
              <i className="fab fa-facebook"></i> Bagikan ke Facebook
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ShareSection;
